import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { CurrencyProvider } from "@/context/CurrencyContext";

import { StoreLayout } from "@/components/store/StoreLayout";
import Home from "@/pages/store/Home";
import Shop from "@/pages/store/Shop";
import ProductDetail from "@/pages/store/ProductDetail";
import Cart from "@/pages/store/Cart";
import Checkout from "@/pages/store/Checkout";
import { PaymentSuccess, PaymentCancel } from "@/pages/store/Payment";
import { Login, Register } from "@/pages/store/Auth";
import Account from "@/pages/store/Account";
import Track from "@/pages/store/Track";
import Category from "@/pages/store/Category";

import { AdminLayout } from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import Products from "@/pages/admin/Products";
import Import from "@/pages/admin/Import";
import Orders from "@/pages/admin/Orders";
import OrderDetail from "@/pages/admin/OrderDetail";
import Customers from "@/pages/admin/Customers";
import Messages from "@/pages/admin/Messages";
import Suppliers from "@/pages/admin/Suppliers";
import Integrations from "@/pages/admin/Integrations";
import Inventory from "@/pages/admin/Inventory";
import Discounts from "@/pages/admin/Discounts";
import Returns from "@/pages/admin/Returns";
import Analytics from "@/pages/admin/Analytics";
import Settings from "@/pages/admin/Settings";
import { Notifications, Payments, Shipping, Reports } from "@/pages/admin/MiscPages";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CurrencyProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<StoreLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/category/:key" element={<Category />} />
                  <Route path="/product/:slug" element={<ProductDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/track" element={<Track />} />
                </Route>

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="products" element={<Products />} />
                  <Route path="import" element={<Import />} />
                  <Route path="orders" element={<Orders />} />
                  <Route path="orders/:id" element={<OrderDetail />} />
                  <Route path="customers" element={<Customers />} />
                  <Route path="messages" element={<Messages />} />
                  <Route path="suppliers" element={<Suppliers />} />
                  <Route path="inventory" element={<Inventory />} />
                  <Route path="shipping" element={<Shipping />} />
                  <Route path="payments" element={<Payments />} />
                  <Route path="returns" element={<Returns />} />
                  <Route path="discounts" element={<Discounts />} />
                  <Route path="analytics" element={<Analytics />} />
                  <Route path="reports" element={<Reports />} />
                  <Route path="integrations" element={<Integrations />} />
                  <Route path="notifications" element={<Notifications />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </CartProvider>
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
